import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { KeyVal } from '../model/af.model';
import { AuthService } from '../service/auth.service';
import { EventService } from '../service/event.service';
import { AttachmentUploadedEvent, UploadEvent } from '../service/events';
import { Subscription } from 'rxjs';
import { KeyValue } from '@angular/common';

@Component({
  selector: 'app-file-dialog',
  templateUrl: './file-dialog.component.html',
  styleUrls: ['./file-dialog.component.scss']
})
export class FileDialogComponent implements OnInit, OnDestroy {

  fileForm: UntypedFormGroup;
  fileDescriptionLookup: KeyVal[];
  ousAttachmentId: string;
  ousAttachments: boolean = false;
  fileFormat: string;
  sub: Subscription;
  inProgress: boolean = false;
  ousAttachmentDesc:string;

  constructor(private userService: AuthService, private _snackBar: MatSnackBar, private eventBus: EventService, public dialogRef: MatDialogRef<FileDialogComponent>, 
    private fb: UntypedFormBuilder, @Inject(MAT_DIALOG_DATA) private data) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.fileDescriptionLookup = this.data.fileDescriptionLookup;
    this.ousAttachments = this.data.ousAttachments;
    this.ousAttachmentId = this.data.ousAttachmentId;
    this.ousAttachmentDesc=this.data.ousAttachmentDesc;
    if(this.data.fileFormat && this.data.fileFormat != ''){
        this.fileFormat=this.data.fileFormat
    }else{
      this.fileFormat="ZIP, PDF, DOC, DOCX, EML, MSG, TIFF, JPEG, GIF, XLS, XLSX, PNG, JPG, PPT and PPTX";
    }
    this.createGroup();
    this.sub = this.eventBus.on(
      AttachmentUploadedEvent,
      (event): void => {
        this.inProgress = event.payload.inProgress;
        if (event.payload.file) {
          this._snackBar.open("Attachment uploaded successfully", "Close", {
            duration: 4000,
          });
          this.dialogRef.close();
        }
      }
    );
  }

  get submit() { return this.fileForm.get('submit') }
  get afId() { return this.fileForm.get('afId') }
  get descOfFileName() { return this.fileForm.get('descOfFileName') }
  get verifyId() { return this.fileForm.get('verifyId') }

  createGroup() {
    this.fileForm = this.fb.group({
      verifyId: [this.userService.getVerifyId()],
      afId: [this.userService.getAfId(), []],
      submit: [false],
      descOfFileName: ['']
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  uploadClick(): void {
    this.eventBus.emit(new UploadEvent({}));
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  valueAscOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return a.value.localeCompare(b.value);
  }
}
